<app-popup *ngIf="displayPopup | async"></app-popup>
<app-secondary-popup *ngIf="displaySecondaryPopup | async"></app-secondary-popup>

<app-header
  [isMenuLoading]="isMenuLoading"
  [menuData]="menuData"
></app-header>
<div
  class="page-content"
  [ngClass]="{ 'sidenav-hidden': isSidenavHidden }"
>
  <app-sidenav
    class="main-sidenav"
    (toggle)="toggleSidenav()"
  ></app-sidenav>
  <div
    class="main-content"
    *ngIf="(isConfigurationLoading$ | async) === false || null; else loading"
  >
    <router-outlet></router-outlet>
  </div>
</div>

<ng-template #loading>
  <app-refresh-page></app-refresh-page>
</ng-template>

<ng-template
  #errorWarningsPopup
  let-popupData="data"
>
  <app-error-warning-modal
    [uuid]="popupData.uuid"
    [data]="popupData.data"
    [source]="popupData.source"
    [options]="popupData.options"
  ></app-error-warning-modal>
</ng-template>